var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7H0.75M14.25 8.875V6.1C14.25 4.83988 14.25 4.20982 14.0048 3.72852C13.789 3.30516 13.4448 2.96095 13.0215 2.74524C12.5402 2.5 11.9101 2.5 10.65 2.5H4.35C3.08988 2.5 2.45982 2.5 1.97852 2.74524C1.55516 2.96095 1.21095 3.30516 0.995235 3.72852C0.75 4.20982 0.75 4.83988 0.75 6.1V12.4C0.75 13.6601 0.75 14.2902 0.995235 14.7715C1.21095 15.1948 1.55516 15.539 1.97852 15.7548C2.45982 16 3.08988 16 4.35 16H7.5M10.5 1V4M4.5 1V4M9.375 13.75L10.875 15.25L14.25 11.875",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/CartIcon.9db723d887982ef6fcb35df7cc395528.svg";
export { ForwardRef as ReactComponent };